import { GDLV2 } from 'react-common-gdlv2';
import { RoutePath } from 'types/global';

export enum PageType {
  HOME = 'HOME',
  FORM = 'FORM',
  SUMMARY = 'SUMMARY',
  UNHAPPY_PATH = 'UNHAPPY PATH',
  ERROR = 'ERROR',
  LOGOUT = 'LOGOUT'
}

export const pageNames: { [index: string]: string } = {
  [RoutePath.FourQuestionVerification]: 'Application Tracking',

  [RoutePath.LoggedOut]: 'Log out',

  [RoutePath.ServerError]: 'Server error'
};

export const pageData = {
  [RoutePath.FourQuestionVerification]: {
    name: pageNames[RoutePath.FourQuestionVerification],
    type: PageType.FORM,
    section: pageNames[RoutePath.FourQuestionVerification]
  },
  [RoutePath.LoggedOut]: {
    name: pageNames[RoutePath.LoggedOut],
    type: PageType.LOGOUT,
    section: pageNames[RoutePath.LoggedOut]
  },
  [RoutePath.ServerError]: {
    name: pageNames[RoutePath.ServerError],
    type: PageType.ERROR,
    section: pageNames[RoutePath.ServerError]
  }
};

export const gdlv2 = GDLV2({
  server: 'Servicing boilerplate',
  brands: {
    'spa.mortgages.natwest.com': 'NatWest',
    'spa.mortgages.rbs.co.uk': 'RBS',
    localhost: 'NatWest'
  },
  applicationDetails: {
    'application-name-1': 'Application name 1'
  },
  queryParamsBlacklist: ['token'],
  pageData
});
